import React, { useState, useEffect } from "react";
import Table from "../../../UI/Table/Table";
import image from "../../../../Resources/images/images.jpg";
import { MdClose, MdDelete, MdEdit } from "react-icons/md";
import MasterDeleteModal from "../../../UI/Model/MasterDeleteModel/MasterDeleteModel";
import { Formik, Form, Field } from "formik";
import * as yup from "yup";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "../../../../HOC/CreateAxios/CreateAxios";
function ViewService({ getBrand }) {
  const [idStore, setIdStore] = useState(false);
  const [message, setMessage] = useState(false);
  const [showModel, setShowModel] = useState(false);
  const [ID, setID] = useState("");
  const [storeID, setStoreID] = useState(false);
  const [storeImage, setStoreImage] = useState("");
  const Schema = yup.object().shape({
    service_name: yup.string().required("Service name is required"),
    price: yup.string().required("Price is required"),
  });
  const [Tbody, setTbody] = useState([]);
  const tHead = [
    { title: "s.nO", width: "10%" },
    { title: "name", width: "20%" },
    { title: "image", width: "20%" },
    { title: "price(Rs)", width: "10%" },
    { title: "action", width: "30%" },
  ];

  const getService = () => {
    axios
      .get("/service")
      .then((res) => {
        console.log(res.data);
        setTbody(res.data.result);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    getService();
  }, []);

  const FormInitial = [
    {
      label: "Service Name",
      apikey: "service_name",
      placeholder: "Enter Service name here !",
      type: "text",
    },

    {
      label: "Service price",
      apikey: "price",
      placeholder: "Enter  price here !",
      type: "number",
    },
    {
      label: "Service image",
      apikey: "image",
      accept: "image/*,.jpg,.png,.jpeg,.mov",
      type: "file",
    },
  ];
  const DeleteItems = () => {
    // console.log(idStore);
    axios
      .delete(`/service/${idStore}`)
      .then((res) => {
        if (res.status === 200) {
          setMessage(false);
          getService(idStore);
          toast.error("Service has been deleted sucessfully");
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const Conformation = (id) => {
    setMessage(true);
    setIdStore(id);
  };
  let ConformationMessage;
  if (message) {
    ConformationMessage = (
      <MasterDeleteModal
        // id={idStore}
        Delete={DeleteItems}
        setMessage={setMessage}
      />
    );
  }
  const Edit = (values) => {
    setID(values);
    // setStoreImage(values?.image);
    // setStoreImage([...values.image]);

    setShowModel(true);
    // console.log(values);
    // setStoreImage([...values.image]);
  };
  console.log(ID);
  useEffect(() => {
    setStoreID(ID);
  }, [ID, storeID]);
  const Submits = (value) => {
    // alert(5);
    console.log(storeImage);
    value.image = storeImage;
    let formData = new FormData();
    formData.append("service_name", value.service_name);
    formData.append("image", value.image);
    formData.append("price", value.price);
    axios
      .patch(`/service/${ID.id}`, formData)
      .then((res) => {
        // console.log(res);
        // alert("working");
        if (res.status === 200) {
          setShowModel(false);
          toast.info("Service has been updated sucessfuly");
          getService();
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const handleChange = (e) => {
    if (e.target.files.length !== 0) {
      setStoreImage(e.target.files[0]);
    }
  };
  let mod;
  mod = (
    <div
      className={`${
        showModel ? " absolute  z-50 top-0 bottom-0 right-0 left-0" : ""
      }`}
    >
      <div
        className={` ${
          showModel ? "translate-y-0 " : "-translate-y-full "
        }  duration-700 delay-300 ease-in-out fixed top-0 bottom-0 right-0 left-0  z-40 `}
      >
        <div
          className=" relative z-50 bg-[white] rounded-md top-[5%]  flex 
         p-5 w-[70%] mx-auto h-fit "
        >
          <div className="w-[95%] my-4">
            <Formik
              initialValues={{
                service_name: ID?.service_name ? ID?.service_name : "",
                image: ID?.image ? ID?.image : "",
                price: ID?.price ? ID?.price : "",
              }}
              validationSchema={Schema}
              onSubmit={(values, { resetForm }) => {
                console.log(values);
                Submits(values);
                resetForm();
              }}
            >
              {({ values, errors, touched, handleSubmit, isSubmitting }) => (
                <Form onSubmit={handleSubmit}>
                  <div className={`   gap-6`}>
                    {FormInitial?.map((val, i) => {
                      if (val.type === "file") {
                        return (
                          <div key={i} className="full ">
                            <div className="capitalize  my-3">
                              <label
                                className="cursor-pointer text-gray-600 font-semibold"
                                htmlFor={val.apikey}
                              >
                                {val.label}
                              </label>
                            </div>

                            {/* <div className="grid grid-cols-12  space-x-1 gap-3 border p-1 h-64 "> */}
                            <label htmlFor="image">
                              <div className=" w-full">
                                <div className="w-full h-96 bg-gray-200 relative  p-1.5 overflow-hidden">
                                  <img
                                    src={
                                      storeImage
                                        ? URL.createObjectURL(storeImage)
                                        : `${process.env.REACT_APP_API_URL}/public/${ID?.image}`
                                    }
                                    alt="Loading..."
                                    className="object-contain mx-5 w-full h-96 object-center"
                                  />
                                </div>
                              </div>
                            </label>
                            {/* </div> */}
                            <input
                              id="image"
                              type={"file"}
                              accept={val.accept}
                              name={val.apikey}
                              onChange={(e) => handleChange(e)}
                              className="bg-white hidden relative z-50  outline-none rounded-sm 
                                    border-none px-2 py-1"
                            />
                            <div
                              className={`${
                                errors[val.apikey] && touched[val.apikey]
                                  ? "text-xs text-red-500 py-[1px] px-2 mt-2 bg-red-50 w-full"
                                  : ""
                              }`}
                            >
                              {errors[val.apikey] && touched[val.apikey]
                                ? errors[val.apikey]
                                : ""}
                            </div>
                          </div>
                        );
                      } else {
                        return (
                          <div key={i} className="full ">
                            <div className="capitalize  my-3">
                              <label
                                className="cursor-pointer text-gray-600 font-semibold"
                                htmlFor={val.apikey}
                              >
                                {val.label}
                              </label>
                            </div>
                            <div className="relative">
                              <Field
                                type={val.type}
                                id={val.apikey}
                                placeholder={val.placeholder}
                                name={val.apikey}
                                className="border border-gray-300 px-3 py-2.5  w-11/12 laptop:w-full rounded-md"
                              />
                            </div>

                            <div
                              className={`${
                                errors[val.apikey] && touched[val.apikey]
                                  ? "text-xs text-red-500 py-[1px] px-2 mt-2 bg-red-50 w-full"
                                  : ""
                              }`}
                            >
                              {errors[val.apikey] && touched[val.apikey]
                                ? errors[val.apikey]
                                : ""}
                            </div>
                          </div>
                        );
                      }
                    })}
                  </div>
                  <div className="flex justify-start  mt-5 w-11/12">
                    <button
                      type="submit"
                      className="bg-green-600 text-white  font-bold capitalize px-5 py-2 rounded-md hover:bg-opacity-70 "
                    >
                      submit
                    </button>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
          <div
            className="absolute top-5 border border-gray-600  text-gray-600 bg-white  
            hover:bg-opacity-60  text-3xl rounded-full p-1 cursor-pointer right-10"
            onClick={() => {
              setShowModel(false);
              setID(null);
              setStoreImage("");
            }}
          >
            <MdClose />
          </div>
        </div>
        {/* )} */}
      </div>
    </div>
  );

  return (
    <div className=" p-6">
      <div
        className={`${
          showModel
            ? "fixed bg-black bg-opacity-10   overflow-auto  z-50 top-0 bottom-0 right-0 left-0"
            : ""
        } `}
      >
        <div
          className={` ${
            showModel ? "translate-y-0  " : "-translate-y-full  "
          }  duration-700 delay-300 ease-in-out   absolute top-0 bottom-0 right-0 left-0  z-40 `}
        >
          {showModel ? mod : ""}
        </div>
      </div>
      <Table celspacing={0} cellPadding={0} Head={tHead}>
        {Tbody.map((val, i) => {
          let image = `${process.env.REACT_APP_API_URL}/public/${val.image}`;
          return (
            <tr key={i} className=" w-full">
              <td className="border-b p-2 text-center"> {i + 1}</td>
              <td className="border-b p-2 text-center">{val.service_name}</td>
              <td className="border-b p-2 ">
                <div className="flex justify-center ">
                  <img
                    src={image}
                    alt="loading ..."
                    // height="100px"
                    // width="100px"
                    className="rounded-full h-24 w-24"
                  />
                </div>
              </td>
              <td className="border-b p-2 text-center">
                <div className="">{val.price} </div>
              </td>
              <td className="border-b p-2 text-center border-r">
                <div className="flex mx-3 gap-2 items-center justify-center">
                  {" "}
                  <div className="">
                    <button
                      className="border border-gray-600 rounded-md  hover:bg-blue-100 hover:text-blue-500 px-2 py-1"
                      onClick={() => Edit(val)}
                    >
                      <MdEdit className="text-2xl" />
                    </button>
                  </div>
                  <div className="">
                    <button
                      className=" capitalize border border-[#9a9a9a] px-2 py-1 rounded-md hover:bg-red-100  hover:text-red-500"
                      onClick={() => Conformation(val.id)}
                    >
                      <MdDelete className="text-2xl" />
                    </button>
                  </div>
                  {ConformationMessage}
                </div>
              </td>
            </tr>
          );
        })}
      </Table>
    </div>
  );
}

export default ViewService;
